import { ActionLogsCSVHeaderLabels, ActionLogsCSVFieldsMapping } from '../types/actionLogsTypes';

const sanitizeValue = (value: any): any => {
  if (typeof value !== 'string') {
    return value;
  }

  return value
    .replace(/[\n\r^]/g, ' ')
    .replace(/,/g, ' ')
    .trim()
    .replace(/\s{2,}/g, ' ');
};

export const convertTableToCSV = <T extends object>(
  rows: T[],
  headerLabels: ActionLogsCSVHeaderLabels = {},
  fieldMapping: ActionLogsCSVFieldsMapping = {},
  sanitizer?: (value: any) => string,
  columnOrder?: string[]
): string => {
  const applySanitizer = sanitizer ?? sanitizeValue;
  if (rows.length === 0) return '';

  const rawHeaders = columnOrder ?? Object.keys(rows[0]);
  const cleanedHeaders = rawHeaders
    .map((field) => {
      const label = headerLabels[field] ?? field;
      return applySanitizer(label);
    })
    .join(',');

  const csvRows = rows.map((row) =>
    rawHeaders
      .map((field) => {
        let val = (row as any)[field];

        if (fieldMapping[field] && fieldMapping[field][val] !== undefined) {
          val = fieldMapping[field][val];
        }

        return applySanitizer(val);
      })
      .join(',')
  );

  return [cleanedHeaders, ...csvRows].join('\n');
};
